function setVouchers(data) {
	return {
		type: 'SET_VOUCHERS',
		payload: data,
	};
}

export { setVouchers };
